






































































































































































































import { Component } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import TabsHeader from "@/components/tabs-header.vue";
import PageRequest from "@/store/entities/page-request";
import Ajax from "../../lib/ajax";
import RegionSelect from "../../components/region-select.vue";
import moment from "moment";
import appconst from "@/lib/appconst";
class PageCourtRequest extends PageRequest {
  courtId: number = null;
  regionId: number = null;
  supplierId: number = null;
  offerDateTypeId: number = null;
  tabValue:number=1;


}

@Component({
  components: { RegionSelect,TabsHeader },
})
export default class MyOffers extends AbpBase {
  edit() {
    this.editModalShow = true;
  }

  //filters
  pagerequest: PageCourtRequest = new PageCourtRequest();

  editModalShow: boolean = false;
  supplierList: Array<any> = [];

  copying: boolean = false;
  copyingSelect: boolean = false;

  regions = [];

  courtList = [];
   isOnSaleList: Array<object> = [
    {
      value: "false",
      label: "下架",
    },
    {
      value: "true",
      label: "上架",
    },
  ];
  headTypes:Array<Object>=[{
    label:'全部报价',
    value:null
  },{
    label:'上月报价',
    value:0
  },{
    label:'本月报价',
    value:1
  },{
    label:'下月报价',
    value:2
  }]

  selectedCourtIds: Array<number> = new Array<number>();
  handleSpan({ row, column, rowIndex, columnIndex }) {
    // 只处理第一列
    if (columnIndex !== 0) {
      return {
        rowspan: 1,
        colspan: 1,
      };
    }

    const currentCourtName =
      row.timeSlot.offerDateSlot.supplierOffer.court.name;
    let rowspan = 1;

    // 查看下一行是否也是相同的球场名称
    for (let i = rowIndex + 1; i < this.list.length; i++) {
      if (
        this.list[i].timeSlot.offerDateSlot.supplierOffer.court.name ===
        currentCourtName
      ) {
        rowspan++;
      } else {
        break;
      }
    }
    // 如果当前行不是合并组的第一行，则不显示该单元格
    if (
      rowIndex > 0 &&
      this.list[rowIndex - 1].timeSlot.offerDateSlot.supplierOffer.court
        .name === currentCourtName
    ) {
      return {
        rowspan: 0,
        colspan: 0,
      };
    }

    // 返回合并属性
    return {
      rowspan,
      colspan: 1,
    };
  }

  get list() {
    return this.$store.state.supplierOfferItem.list;
  }
  get loading() {
    return this.$store.state.supplierOfferItem.loading;
  }
  get dateTypes() {
    return this.$store.state.offerDateType.list;
  }
 /**
   * @description：报价的上下架
   */
  async updateIsOnSale(supplierOfferItemId, isOnSale) {
    let data = {
      supplierOfferItemId,
      isOnSale,
    };
    await this.$store
      .dispatch({
        type: "supplierOfferItem/updateIsOnSale",
        data,
      })
      .then((res) => {
        if (res && res.data && res.data.result == null) {
          this.getpage();
        }
      });
  }
  async exportOffer() {
    try {
      let res = await this.$store.dispatch({
        type: "supplierOfferItem/exportOffers",
      });
      if (res && res.data && res.data.result) {
        let url = `${appconst.remoteServiceBaseUrl}${res.data.result}`;
        window.open(url, "_blank");
      }
    } catch (error) {
      console.error("导出 Excel 失败:", error);
    }
  }

  async saveOffer(row) {
    if(row.payMethod==1){
      row.amount=row.price;
    }
    await this.$store.dispatch({
      type: "supplierOfferItem/update",
      data: row,
    });
    this.$Message.success({
      content: "保存成功",
    });
  }

  copyOffer() {
    this.$store.dispatch({
      type: "supplierOffer/copyOffersToNextMonth",
    });
  }
  async getSupplierList() {
    return await this.$store
      .dispatch({
        type: "supplier/GetAllSupplierListLabelAndValue",
      })
      .then((res) => {
        if (res && res.data && res.data.result) {
          this.supplierList = res.data.result;
        }
      });
  }
  pageChange(page: number) {
    this.$store.commit("supplierOfferItem/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("supplierOfferItem/setPageSize", pagesize);
    this.getpage();
  }
  search() {
    this.$store.commit("supplierOfferItem/setCurrentPage", 1);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters

    await this.$store.dispatch({
      type: "supplierOfferItem/getAllFlat",
      data: this.pagerequest,
    });
  }

  get pageSize() {
    return this.$store.state.supplierOfferItem.pageSize;
  }
  get totalCount() {
    return this.$store.state.supplierOfferItem.totalCount;
  }
  get currentPage() {
    return this.$store.state.supplierOfferItem.currentPage;
  }
  get offerDateTypeDics() {
    return this.$store.state.common.offerDateTypeDic;
  }
  get paymethods() {
    return this.$store.state.common.paymethodsDic;
  }
  columns = [
    {
      title: "球场名称",
      width: 170,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.timeSlot.offerDateSlot.supplierOffer.court.name
        );
      },
    },
    {
      title: "供应商名称",
      width: 110,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.timeSlot.offerDateSlot.supplierOffer.supplier.name
        );
      },
    },
    {
      title: "供应商报价",
      key: "offerPrice",
      slot: "offerPrice",
    },
    {
      title: "加利润后价格",
      slot: "price",
    },
    {
      title: "预付款",
      slot: "amount",
    },
    {
      title: "日期类型",
      render: (h: any, params: any) => {
        return h("span", this.offerDateTypeDics[params.row.offerDateTypeId]);
      },
    },
     {
      title: "上架/下架",
      render: (h: any, params: any) => {
        return h("span", params.row.isOnSale?'上架':'下架');
      },
    },
    {
      title: "开始时间",
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          `${params.row.timeSlot.startTime}-${params.row.timeSlot.endTime}`
        );
      },
    },
    {
      title: "开始日期",
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          `${moment(params.row.timeSlot.offerDateSlot.startDate).format(
            "YYYY-MM-DD"
          )} - ${moment(params.row.timeSlot.offerDateSlot.endDate).format(
            "YYYY-MM-DD"
          )}`
        );
      },
    },

    {
      title: "支付方式",
      key: "payMethod",
      render: (h: any, params: any) => {
        return h("span", this.paymethods[params.row.payMethod]);
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 120,
      slot: "action",
      align: "center",
    },
  ];
  async getAllCourtNames() {
    let reponse = await Ajax.get("/api/services/app/Court/GetAllCourtNames");
    this.courtList = reponse.data.result;
  }
  async created() {
    this.getAllCourtNames();
    this.getSupplierList();
    this.getpage();
    await this.$store.dispatch({
      type: "offerDateType/getAll",
      data: {
        skipCount: 0,
        maxResultCount: 200,
      },
    });
  }
}
